import { render, staticRenderFns } from "./BoardViewLog.vue?vue&type=template&id=8b397172&scoped=true"
import script from "./BoardViewLog.ts?vue&type=script&lang=ts&external"
export * from "./BoardViewLog.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardViewLog.vue?vue&type=style&index=0&id=8b397172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b397172",
  null
  
)

export default component.exports